const Button = ({
  text = "",
  icon: Icon,
  onClick = () => {},
  onClear = () => {},
  type = "button",
  disabled = false,
  loading = false,
  loadingText = "Loading...",
  // Visual styles
  iconBg = "",
  iconColor = "",
  iconPosition = "left",
  textColor = "",
  bgColor = "",
  borderColor = "",
  hoverBg = "",
  iconSize = "",
  textWeight = "",
  textSize = "",

  // Layout controls
  rounded = "",
  padding = "",
  iconSpacing = "",
  textSpacing = "",
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      onClear={onClear}
      disabled={disabled || loading}
      className={`inline-flex flex-wrap items-center transition-all duration-200 ${className} ${
        disabled || loading ? "opacity-50 cursor-not-allowed" : ""
      } uppercase`}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin -ml-1 mr-3 h-4 w-4 text-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <span className={`${textWeight} ${textSize} ${textSpacing}`}>
            {loadingText || text}
          </span>
        </>
      ) : (
        <>
          {Icon && (
            <span
              className={`inline-flex items-center justify-center  ${iconSpacing} ${iconBg} ${iconColor} ${iconPosition} rounded-full`}
            >
              <Icon className={`${iconSize}`} />
            </span>
          )}
          <span className={`${textWeight} ${textSize} ${textSpacing}`}>
            {text}
          </span>
        </>
      )}
    </button>
  );
};

export default Button;
